<template>
  <TournamentForm />
</template>

<script>
import TournamentForm from "@/components/tournament/TournamentForm.vue";

export default {
  name: "TournamentCreatePage",
  components: {
    TournamentForm,
  },
};
</script>
